import { Suspense } from 'react';
import { useDynamicIcon } from './hook';
import type { IconModule } from './index.types';

interface DynamicIconProps {
	iconName: string;
	loading?: React.ReactNode;
	className?: string;
	iconImportMap: Record<string, () => Promise<IconModule>>;
}

const DynamicIcon: React.FC<DynamicIconProps> = ({
	iconName,
	loading = <div className="w-6 h-6 bg-gray-300 rounded animate-pulse" />,
	iconImportMap,
	...props
}) => {
	const IconComponent = useDynamicIcon(iconName, iconImportMap);

	// If we have an IconComponent, render it with Suspense
	if (IconComponent) {
		return (
			<Suspense fallback={loading}>
				<IconComponent {...props} />
			</Suspense>
		);
	}

	// Show loading state while the icon is being loaded (IconComponent is null initially)
	return loading;
};
export default DynamicIcon;
